<template>
  <div class="indexPage page swiper-container swiper-no-swiping" ref="swiperContainer">
    <div class="swiper-wrapper">
      <content1 :loadEnd='loadEnd'></content1>
      <content2></content2>
      <content3></content3>
      <content4></content4>
      <content5></content5>
      <content6></content6>
      <content7></content7>
      <content8></content8>
    </div>
    

    <toNextBtn></toNextBtn>

    <singleWork></singleWork>
    <mainTitle></mainTitle>
    <musicBox v-if="showMusic"></musicBox>
    <mainNavs></mainNavs>
    <loading :loadEnd='loadEnd' @changeLoadState='changeLoadState'></loading>
  </div>
</template>

<script>
import Swiper from 'swiper'
import content1 from 'components/content1/content1.vue'
import content2 from 'components/content2/content2.vue'
import content3 from 'components/content3/content3.vue'
import content4 from 'components/content4/content4.vue'
import content5 from 'components/content5/content5.vue'
import content6 from 'components/content6/content6.vue'
import content7 from 'components/content7/content7.vue'
import content8 from 'components/content8/content8.vue'
import toNextBtn from 'components/toNextBtn/toNextBtn.vue'
import mainNavs from 'components/mainNavs/mainNavs.vue'

export default {
  components: {
    content1,
    content2,
    content3,
    content4,
    content5,
    content6,
    content7,
    content8,
    toNextBtn,
    mainNavs,
  },
  data () {
    return {
      mySwiper: null,
      loadEnd: false, // 是否加载结束
    }
  },
  watch: {
    '$store.state.nowPage' ( nowPage ) {
      if ( typeof nowPage === 'number' && this.mySwiper ) {
        this.mySlideTo(nowPage)
      }
    }
  },
  computed: {
    nowPage () {
      return this.$store.state.nowPage
    },
    showMusic () {
      return this.$store.state.showMusic
    }
  },
  mounted () {
    this.initSwiper()
  },

  methods: {
    initSwiper () { // 初始化swiper
      let _this = this
      this.mySwiper = new Swiper(this.$refs.swiperContainer, {
        direction : 'vertical',
        paginationClickable: true,
        observer: true, 
        observeParents: true,
        initialSlide: _this.nowPage,
      })
    },

    mySlideTo (e) { // 划去指定的swiper
      this.mySwiper.slideTo(e, 300, false)
    },

    changeSingleState () { // 修改弹窗显示隐藏状态
      this.showSingleWork = !this.showSingleWork
    },

    changeLoadState () {
      this.loadEnd = !this.loadEnd
    },

  },
}
</script>
<style lang="stylus">
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './index.styl'
</style>